import { useEffect } from "react";

// Swaps the page head to the given app's name, manifest and icons so each one installs on its own.
export const useAppHead = (app) => {
  useEffect(() => {
    const tags = [
      ["link", "manifest", app.manifest],
      ["link", "apple-touch-icon", app.touchIcon],
      ["link", "icon", app.icon],
      ["meta", "apple-mobile-web-app-title", app.short],
      ["meta", "application-name", app.name],
      ["meta", "apple-mobile-web-app-capable", "yes"],
      ["meta", "mobile-web-app-capable", "yes"],
      ["meta", "apple-mobile-web-app-status-bar-style", "black-translucent"],
      ["meta", "theme-color", app.bg],
    ];
    const undo = [];
    const prevTitle = document.title;
    document.title = app.name;
    tags.forEach(([tag, key, value]) => {
      const attr = tag === "link" ? "rel" : "name";
      const prop = tag === "link" ? "href" : "content";
      const found = [...document.head.querySelectorAll(`${tag}[${attr}="${key}"]`)];
      if (found.length) {
        found.forEach((el) => {
          const old = el.getAttribute(prop);
          el.setAttribute(prop, value);
          undo.push(() => el.setAttribute(prop, old));
        });
      } else {
        const el = document.createElement(tag);
        el.setAttribute(attr, key);
        el.setAttribute(prop, value);
        document.head.appendChild(el);
        undo.push(() => el.remove());
      }
    });
    const titleObserver = new MutationObserver(() => {
      if (document.title !== app.name) document.title = app.name;
    });
    titleObserver.observe(document.querySelector("title"), { childList: true });
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/temple-sw.js", { scope: app.base }).catch(() => {});
    return () => {
      titleObserver.disconnect();
      undo.forEach((f) => f());
      document.title = prevTitle;
    };
  }, [app]);
};
